import { OnboardingStep } from "../types/OnboardingStep";

export const onboardingSteps: OnboardingStep[] = [
  {
    label: "Set decarbonization target",
    completedLabel: "Decarbonization target set",
    shortLabel: "Target",
    description: "Choose a baseline year to measure your progress",
    index: 0,
    href: "/target",
    buttonText: "Set target",
  },
  {
    label: "Set emissions profile",
    completedLabel: "Emissions profile set",
    shortLabel: "Emissions",
    description: "Estimate your emissions by source and/or type",
    index: 1,
    href: "/baseline",
    buttonText: "Set profile",
  },
  {
    label: "Select your solutions",
    completedLabel: "Select your solutions",
    shortLabel: "Solutions",
    description: "Break down your plan into Scope 1 and 2 solutions",
    index: 2,
    href: "/plan",
    buttonText: "Customize",
  },
  {
    label: "Email your plan",
    completedLabel: "Plan emailed",
    shortLabel: "Report",
    description: "Email yourself an actionable summary",
    index: 3,
    href: "/email-plan",
    buttonText: "Email plan",
  },
  {
    label: "Get in touch",
    completedLabel: "Get in touch",
    shortLabel: "Action",
    description:
      "Build a project-level action plan. Cascade Energy can help you identify, assess, and find funding for the best decarbonization projects. Contact us to get started.",
    index: 4,
    href: "/contact-us",
    buttonText: "Find Projects With Us",
  },
];
